import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import SearchBar from '@/components/feature/SearchBar';

const NAV_ITEMS = [
  { to: '/', label: '首页', end: true },
  { to: '/category/movie', label: '电影', end: false },
  { to: '/category/tv', label: '电视剧', end: false },
  { to: '/about', label: '关于', end: false },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
      isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
    }`;

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled ? 'border-background-200 bg-background-50/95 backdrop-blur' : 'border-transparent bg-background-50'
      }`}
    >
      <div className="flex w-full items-center gap-4 px-4 py-3 md:px-8 md:py-4">
        <Link to="/" className="flex shrink-0 cursor-pointer items-center gap-2.5" aria-label="美丽小蜜桃3影视大全首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-base font-bold tracking-tight text-foreground-950 md:text-lg">美丽小蜜桃3</span>
            <span className="mt-0.5 text-[11px] tracking-[0.2em] text-primary-600">影视大全</span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-64 lg:block xl:w-80">
          <SearchBar />
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="打开菜单"
          aria-expanded={menuOpen}
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <div className="mb-3">
            <SearchBar />
          </div>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}